import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import LineOnSideHeader from '~/components/atoms/LineOnSideHeader.vue';
import RatingStars from '~/components/molecules/Global/RatingStars.vue';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

var ProductStock = function ProductStock() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/atoms/Product/ProductStock.vue');
};

export default {
  name: 'ProductOffersModal',
  components: {
    MdmModal: MdmModal,
    LineOnSideHeader: LineOnSideHeader,
    RatingStars: RatingStars,
    ProductStock: ProductStock
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    offers: {
      type: Object,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      items: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    discountDeadline: function discountDeadline() {
      return '20/02/2020';
    }
  }),
  methods: {
    merchantUrl: function merchantUrl(reference) {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/m/").concat(reference);
    },
    currentPrice: function currentPrice(offer) {
      if (offer.product.price.sales.amount) {
        return offer.product.price.sales.formatted;
      }

      return offer.product.price.base.formatted;
    }
  }
};